import React, { useState } from 'react';
import moment from 'moment';
import 'moment/locale/sv';
import { A } from 'hookrouter';
import { getIcon } from './field_inputs/shared/FormatHelpers';

export const OwnerTag = ({ content, activeItem }) => {
    const text = activeItem && activeItem.name ? activeItem.name : content;
    if (text) {
        return (
            <A className='owner-item' title={activeItem?.name ?? 'unknown'} href={activeItem?.link ?? '/404'}>
                {text}
            </A>
        );
    } else {
        return <div className='mr-2'>{text}</div>;
    }
};

export const OwnerDropdownTag = ({ item }) => {
    return (
        <div className='d-flex flex-column my-auto text-center align-items-center pr-3' style={{ height: 45 }}>
            <div className='h-100'>
                <h3 className='mb-0'>{item.owner.name}</h3>
                <p className='d-flex ml-auto mb-0'>Owner</p>
            </div>
        </div>
    );
};

function renderTagWithLink(icon, item, missingText) {
    const link = item?.link ?? undefined;

    return (
        <>
            {icon}
            <div className='mr-1' />
            {link && <a href={item.link}>{item?.name ?? missingText}</a>}
            {!link && <p>{item?.name ?? missingText}</p>}
            <div className='mr-2' />
        </>
    );
}

export const PersonTag = ({ item }) => {
    const icon = getIcon('person');

    return renderTagWithLink(icon, item, 'Kontaktperson saknas');
};

export const CustomerTag = ({ item }) => {
    const icon = getIcon('organization');

    return renderTagWithLink(icon, item, 'Kund saknas');
};

export const SectionTag = ({ content }) => {
    return (
        <span className='d-flex justify-content-center align-items-center w-100 my-4'>
            <div
                className='d-flex badge badge-pill badge-secondary justify-content-center align-items-center'
                style={{ width: 100, height: 30 }}>
                <h4 className='my-auto'>{content}</h4>
            </div>
        </span>
    );
};

export const DateTag = ({ isColorActive, itemDate, itemType }) => {
    if (itemDate !== undefined && itemDate !== null && !(itemDate instanceof Date)) itemDate = new Date(itemDate);

    const check = itemDate !== null && itemDate !== undefined;
    const [itemTime] = useState(check ? itemDate.getTime() : new Date().getTime());
    const [currentTime] = useState(new Date().getTime());
    let displayDate;

    if (itemType === 'activity') displayDate = check ? moment(itemDate).local().format('D MMMM YYYY') : '(datum saknas)';
    else displayDate = check ? moment(itemDate).local().format('D MMMM YYYY HH:mm') : '(datum saknas)';

    return <p className={`my-auto mr-2 ${isColorActive ? (itemTime >= currentTime ? 'c-green' : 'c-red') : ''}`}>{displayDate}</p>;
};

export const DateOwnerTag = ({ isColorActive, date, user, itemType }) => {
    return (
        <div className='d-flex flex-row'>
            <DateTag isColorActive={isColorActive} itemDate={date} itemType={itemType} />
            <p className='d-flex justify-content-center align-items-center my-auto mr-2'>*</p>
            <OwnerTag activeItem={user} content={user?.name ?? 'Inaktiverad användare'} />
        </div>
    );
};
